export const translations = {
  en: {
    visit: 'visit our website',
    floor_plan: 'FLOOR PLAN',
    share: 'SHARE',
    rate: 'RATE APARTMENT',
    vr_mode: 'VR MODE',
    auto_rotate: 'AUTO-ROTATE',
    gyroscope: 'GYROSCOPE',
    fullscreen: 'FULLSCREEN',
    screenshot: 'SCREENSHOT',
    guide_title: 'How to use the tour?',
    move_keyboard: 'Look around the apartment by using mouse or keyboard arrows',
    move_finger: 'Look around the apartment by sliding your finger on the screen or turning device',
    next_room: 'To see the next room, click on the white icon',
    loading: 'Loading',
    disclaimer: 'The information contained on the site and site itself does not constitute an offer for the purposes of the Civil Code',
    error_no_webgl: 'Your device doesn\'t seem to support WebGL. Find out how to get it ',
    error_context_lost: 'Please try again by refreshing your browser',
    something_wrong: 'Something went wrong',
    webgl_link: 'here',
    share_to_social_title: 'Share apartment tour',
    share_to_social_description: 'Share your apartment tour with friends on social media or ',
    share_to_social_description_span: 'copy link',
    rate_apartment_title: 'How do you like this apartment?',
    rate_apartment_description: 'Share your opinion about the apartment by rating it on a scale of 1 to 5',
    rate_apartment_thankyou_title: 'Thank you!',
    rate_apartment_thankyou_description: 'Your opinion means a lot to us',
    gyroscope_guides: {
      ios12: {
        gyroscope_usage: 'To use the virtual reality feature go to:',
        settings: 'Settings',
        safari: 'Safari',
        privacy_and_security: 'Privacy & Security',
        enable_prefix: 'Then, enable',
        motion_and_orientation_access: 'Motion & Orientation Access',
        enable_suffix: 'option and reload the page.',
      },
      ios13: {
        gyroscope_usage: 'To use the virtual reality, please click the button below:',
        permission_button: 'GYROSCOPE',
        toggle_gyroscope: 'You can turn the gyroscope on and off at any time by clicking the gyroscope button on the bottom of the screen.',
        cancel_permission: 'You recently canceled gyroscope access, if you want to change that, close and reopen the browser',
        not_supported: 'Your iPhone has a damaged gyroscope or is not supported by the application',
      },
    },
    roomsTitle: {
      living_room: 'LIVING ROOM',
      bedroom: 'BEDROOM',
      bathroom: 'BATHROOM',
      move_straight: 'GO STRAIGHT',
      children_room: 'CHILDREN\'S ROOM',
      kitchen: 'KITCHEN',
      stairs: 'STAIRS',
      toilet: 'TOILET',
      single_bathroom: 'BATHROOM',
    },
  },
  pl: {
    visit: 'odwiedź stronę',
    floor_plan: 'PLAN MIESZKANIA',
    share: 'UDOSTĘPNIJ',
    rate: 'OCEŃ MIESZKANIE',
    vr_mode: 'TRYB VR',
    auto_rotate: 'AUTOOBRÓT',
    gyroscope: 'ŻYROSKOP',
    fullscreen: 'PEŁNY EKRAN',
    screenshot: 'ZRZUT EKRANU',
    guide_title: 'Jak korzystać z wycieczki?',
    move_keyboard: 'Poruszaj się za pomocą myszki lub strzałek na klawiaturze',
    move_finger: 'Poruszaj się przesuwając palcem po ekranie lub obracając urządzenie',
    next_room: 'Aby przejść do kolejnego pomieszczenia, kliknij w jego ikonę',
    loading: 'Ładowanie',
    disclaimer: 'Przedstawiona aranżacja lokalu jest przykładowa, wizualizacje w tym zakresie mają charakter poglądowy oraz informacyjny i nie stanowią oferty w rozumieniu Kodeksu Cywilnego',
    something_wrong: 'Coś poszło nie tak',
    error_no_webgl: 'Twoje urządzenie nie wspiera WebGL. Dowiedz się więcej',
    webgl_link: 'tutaj',
    error_context_lost: 'Spróbuj ponownie odświeżając przeglądarkę',
    share_to_social_title: 'Udostępnij wycieczkę',
    share_to_social_description: 'Podziel się wycieczką ze znajomymi w mediach społecznościowych lub ',
    share_to_social_description_span: 'skopiuj link',
    rate_apartment_title: 'Jak podoba Ci się to mieszkanie?',
    rate_apartment_description: 'Podziel się swoją opinią na temat mieszkania oceniając je w skali od 1 do 5',
    rate_apartment_thankyou_title: 'Dziękujemy!',
    rate_apartment_thankyou_description: 'Twoja opinia dużo dla nas znaczy',
    gyroscope_guides: {
      ios12: {
        gyroscope_usage: 'Aby skorzystać z funkcji wirtualnej rzeczywistości, przejdź do:',
        settings: 'Ustawienia',
        safari: 'Safari',
        privacy_and_security: 'Prywatność i Ochrona',
        enable_prefix: 'A następnie, włącz opcję',
        motion_and_orientation_access: 'Dostęp do ruchu i orientacji',
        enable_suffix: 'i odśwież stronę',
      },
      ios13: {
        gyroscope_usage: 'Aby skorzystać z funkcji wirtualnej rzeczywistości, kliknij przycisk poniżej:',
        permission_button: 'ŻYROSKOP',
        toggle_gyroscope: 'Możesz włączyć i wyłączyć żyroskop w każdym momencie, klikając na przycisk żyroskopu na dole ekranu.',
        cancel_permission: 'Anulowałeś dostęp do żyroskopu, jeśli chcesz zmienić swoją decyzję, zamknij i otwórz ponownie przeglądarkę',
        not_supported: 'Twój iPhone ma uszkodzony żyroskop lub nie jest wspierany przez aplikację',
      },
    },
    roomsTitle: {
      living_room: 'POKÓJ DZIENNY',
      bedroom: 'SYPIALNIA',
      bathroom: 'ŁAZIENKA',
      move_straight: 'PRZEJDŹ DO PUNKTU',
      children_room: 'POKÓJ DZIECKA',
      kitchen: 'KUCHNIA',
      stairs: 'SCHODY',
      toilet: 'TOALETA',
      single_bathroom: 'ŁAZIENKA',
    },
  },
};
